export const UPLOADED_LOGO = "UPLOADED_LOGO";
